<template>
  <div>
    <template v-if="!getTextModel">
      <el-select
        v-model="form[item.bind]"
        v-bind="item"
        v-loadmore="item.loadMore"
        clearable
        @change="
          (val) => {
            item.change && item.change(val, item);
          }
        "
      >
        <el-option
          v-for="(op, i) in (enums[item.dataList] || utils.dictionary.getDict(item.dataList))"
          :key="'select_' + i"
          :disabled="op.disabled"
          :label="item.label ? op[item.label] : op.dataName"
          :value="item.value ? op[item.value] : op.dataValue"
          v-bind="op"
        ></el-option>
      </el-select>
    </template>
    <div v-else>
      {{ getTextContent }}
    </div>
  </div>
</template>

<script>
import utils from "../../SrUtils/index";
export default {
  name: "FormItemSelect",
  data() {
    return {
      utils
    }
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
    enums: {
      type: Object,
    },
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
    getTextContent() {
      let val = this.form[this.item.bind];
      let content = "";
      if (val) {
        if (Object.prototype.toString.call(val) === "[object String]" || Object.prototype.toString.call(val) === "[object Number]") {
          content = this.getNameByVal(val);
        } else if (Object.prototype.toString.call(val) === "[object Array]" && val.length>0) {
          val.map((valItem, valIndex) => {
            if (valIndex == 0) {
              content += this.getNameByVal(valItem);
            } else {
              content += ", " + this.getNameByVal(valItem);
            }
          });
        } else {
          content = "-";
        }
      } else {
        content = "-";
      }
      return content;
    },
  },
  methods: {
    getNameByVal(val) {
      let content = "";
      let dataList = this.enums[this.item.dataList] || this.utils.dictionary.getDict(this.item.dataList);
      for (let i = 0, len = dataList.length; i < len; i++) {
        let eItem = dataList[i];
        if (this.item.value) {
          // 如果定义了label字段，则eItem[this.item.label]是对应的值
          if (eItem[this.item.value] == val) {
            content = this.item.label ? eItem[this.item.label] : eItem.dataName;
            break;
          }
        } else {
          // 否则按默认的eItem.dataValue来取
          if (eItem.dataValue == val) {
            content = this.item.label ? eItem[this.item.label] : eItem.dataName;
            break;
          }
        }
      }
      if (content == "" && val != "") {
        content = val
      }
      return content;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// packages/SrAdd/components/form-item-select.vue